import type { LayoutHotspotListItem } from '../types/types';

/** Normalizes both the flat and nested hotspot list responses used by Ironview 360. */
export const normalizeIronview360LayoutHotspot = (
  item: unknown,
): LayoutHotspotListItem | null => {
  if (!item || typeof item !== 'object') return null;

  const source = item as Record<string, unknown>;
  const hotspot =
    (source.hotspot as Record<string, unknown> | undefined) ?? source;
  const id = hotspot.id;
  if (id == null) return null;

  const rawIssueCounts =
    (hotspot.open_issue_counts as Record<string, unknown> | undefined) ??
    (source.open_issue_counts as Record<string, unknown> | undefined) ??
    {};
  const observations = Number(rawIssueCounts.observations ?? 0);
  const punchItems = Number(rawIssueCounts.punch_items ?? 0);
  const rfis = Number(rawIssueCounts.rfis ?? 0);
  const submittals = Number(rawIssueCounts.submittals ?? 0);
  const safety = Number(rawIssueCounts.safety ?? 0);

  return {
    id: Number(id),
    photo_id: Number(
      hotspot.photo_id ??
        (hotspot.photo as number | undefined) ??
        (source.photo_id as number | undefined) ??
        0,
    ),
    title:
      (hotspot.title as string | null | undefined) ??
      (source.title as string | null | undefined) ??
      null,
    pitch: Number(hotspot.pitch ?? 0),
    yaw: Number(hotspot.yaw ?? 0),
    hfov: Number(hotspot.hfov ?? 0),
    created_at: String(hotspot.created_at ?? source.created_at ?? ''),
    updated_at: String(hotspot.updated_at ?? source.updated_at ?? ''),
    overlay_count: Number(hotspot.overlay_count ?? source.overlay_count ?? 0),
    open_issue_counts: {
      observations,
      punch_items: punchItems,
      rfis,
      submittals,
      safety,
      total: Number(
        rawIssueCounts.total ??
          observations + punchItems + rfis + submittals + safety,
      ),
    },
    created_by_display:
      (hotspot.created_by_display as string | null | undefined) ??
      (hotspot.created_by as string | null | undefined) ??
      (source.created_by_display as string | null | undefined) ??
      null,
    layout_name:
      (hotspot.layout_name as string | null | undefined) ??
      (source.layout_name as string | null | undefined) ??
      null,
    photo_index:
      hotspot.photo_index != null
        ? Number(hotspot.photo_index)
        : source.photo_index != null
          ? Number(source.photo_index)
          : null,
  };
};
